import React from 'react';
import HeaderComponent from './Headercomponent'; // Import the HeaderComponent

const RefundPolicy = () => {
  // Inline styles
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      padding: '20px',
    },
    scrollView: {
      maxWidth: '800px',
      width: '100%',
    },
    heading: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: 'green', // Theme color
      marginBottom: '10px',
    },
    subheading: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: 'green', // Theme color
      marginTop: '20px',
      marginBottom: '10px',
    },
    paragraph: {
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'justify',
      marginBottom: '10px',
    },
    listItem: {
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'justify',
      marginBottom: '5px',
    },
    bold: {
      fontWeight: 'bold',
    },
  };

  return (
    <div>
      {/* Add the HeaderComponent */}
      <HeaderComponent />

      {/* Refund Policy Content */}
      <div style={styles.container}>
        <div style={styles.scrollView}>
          <h1 style={styles.heading}>Refund Policy</h1>

          <p style={styles.paragraph}>
            <span style={styles.bold}>Introduction</span>
            {"\n\n"}Lihen Pharmacy Limited is committed to your satisfaction. If you have purchased drugs from Lihen Pharmacy Limited and are unhappy with the product received for any reason, you may be eligible for a refund/partial refund if requested within 30 minutes of the original delivery time.
          </p>

          <h2 style={styles.subheading}>Refund of Products</h2>
          <p style={styles.paragraph}>
            To be eligible for return and refund, the following steps must be taken:
          </p>
          <p style={styles.listItem}>
            <span style={styles.bold}>1. Refund must be requested in writing</span> by contacting Lihenpharmacy@gmail.com.
          </p>
          <p style={styles.listItem}>
            <span style={styles.bold}>2. The request for refund</span> must be made within 30 minutes of the original delivery time.
          </p>
          <p style={styles.listItem}>
            <span style={styles.bold}>3. Drugs must be returned to Lihen Pharmacy Limited immediately</span>, according to the instructions you will receive upon contacting Lihenpharmacy@gmail.com as directed in step 1.
          </p>
          <p style={styles.listItem}>
            <span style={styles.bold}>4. The item(s) must be unused and returned in the original packaging</span>, in like-new or re-sellable condition, as determined in Lihen Pharmacy Limited's sole, reasonable discretion.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;